/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CouponPayVo } from './CouponPayVo';
import {
    CouponPayVoFromJSON,
    CouponPayVoFromJSONTyped,
    CouponPayVoToJSON,
    CouponPayVoToJSONTyped,
} from './CouponPayVo';

/**
 * 
 * @export
 * @interface PaymentCreateReqVo
 */
export interface PaymentCreateReqVo {
    /**
     * 账单ID列表
     * @type {Array<number>}
     * @memberof PaymentCreateReqVo
     */
    billIds: Array<number>;
    /**
     * 用户ID
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    userId: number;
    /**
     * 支付类型：1-储蓄卡，2-信用卡，3-预存款支付（钱包）
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    payType: number;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof PaymentCreateReqVo
     */
    cardHolderName?: string;
    /**
     * 钱包支付金额
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    walletPay?: number;
    /**
     * 赠送金支付金额
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    bonusPay?: number;
    /**
     * 卡支付金额（信用卡时已含手续费）
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    cardPay?: number;
    /**
     * 信用卡手续费（仅信用卡支付时需要传入）
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    creditCardFee?: number;
    /**
     * 积分支付金额
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    pointsPay?: number;
    /**
     * 货币代码，默认KRW
     * @type {string}
     * @memberof PaymentCreateReqVo
     */
    currencyCode?: string;
    /**
     * 优惠券列表（每个账单最多一张）
     * @type {Array<CouponPayVo>}
     * @memberof PaymentCreateReqVo
     */
    couponPays?: Array<CouponPayVo>;
    /**
     * 是否发送短信：0-不发送，1-发送
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    sendSms?: number;
    /**
     * 前端计算的实际支付金额（用于校验）
     * @type {number}
     * @memberof PaymentCreateReqVo
     */
    actualPayAmount: number;
}

/**
 * Check if a given object implements the PaymentCreateReqVo interface.
 */
export function instanceOfPaymentCreateReqVo(value: object): value is PaymentCreateReqVo {
    if (!('billIds' in value) || value['billIds'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('payType' in value) || value['payType'] === undefined) return false;
    if (!('actualPayAmount' in value) || value['actualPayAmount'] === undefined) return false;
    return true;
}

export function PaymentCreateReqVoFromJSON(json: any): PaymentCreateReqVo {
    return PaymentCreateReqVoFromJSONTyped(json, false);
}

export function PaymentCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billIds': json['billIds'],
        'userId': json['userId'],
        'payType': json['payType'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'walletPay': json['walletPay'] == null ? undefined : json['walletPay'],
        'bonusPay': json['bonusPay'] == null ? undefined : json['bonusPay'],
        'cardPay': json['cardPay'] == null ? undefined : json['cardPay'],
        'creditCardFee': json['creditCardFee'] == null ? undefined : json['creditCardFee'],
        'pointsPay': json['pointsPay'] == null ? undefined : json['pointsPay'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'couponPays': json['couponPays'] == null ? undefined : ((json['couponPays'] as Array<any>).map(CouponPayVoFromJSON)),
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'actualPayAmount': json['actualPayAmount'],
    };
}

export function PaymentCreateReqVoToJSON(json: any): PaymentCreateReqVo {
    return PaymentCreateReqVoToJSONTyped(json, false);
}

export function PaymentCreateReqVoToJSONTyped(value?: PaymentCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billIds': value['billIds'],
        'userId': value['userId'],
        'payType': value['payType'],
        'cardHolderName': value['cardHolderName'],
        'walletPay': value['walletPay'],
        'bonusPay': value['bonusPay'],
        'cardPay': value['cardPay'],
        'creditCardFee': value['creditCardFee'],
        'pointsPay': value['pointsPay'],
        'currencyCode': value['currencyCode'],
        'couponPays': value['couponPays'] == null ? undefined : ((value['couponPays'] as Array<any>).map(CouponPayVoToJSON)),
        'sendSms': value['sendSms'],
        'actualPayAmount': value['actualPayAmount'],
    };
}

